(function () {
    'use strict';
    var root = document.querySelector('main.hl');
    if (!root) return;
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Landing terminal: play audit → apply → confirm, then let the visitor drive. */
    var tty = root.querySelector('[data-hl-tty]');
    if (tty) {
        var cmds = tty.querySelector('.hl-tty-cmds'),
            pres = tty.querySelectorAll('pre[data-step]'),
            btns = cmds.querySelectorAll('button'),
            timers = [], auto = true;
        var clear = function () { timers.forEach(clearTimeout); timers = []; };
        var later = function (f, ms) { timers.push(setTimeout(f, ms)); };
        var show = function (step, done) {
            clear();
            var pre;
            pres.forEach(function (p) { p.classList.toggle('is-on', p.dataset.step === step); if (p.dataset.step === step) pre = p; });
            btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.step === step)); });
            var lines = pre.querySelectorAll('span'), cmd = pre.querySelector('b'), full = cmd.dataset.full || (cmd.dataset.full = cmd.textContent);
            if (still) { lines.forEach(function (l) { l.classList.remove('is-wait'); }); cmd.textContent = full; if (done) later(done, 3500); return; }
            lines.forEach(function (l, i) { if (i) l.classList.add('is-wait'); });
            cmd.textContent = '';
            var i = 0;
            (function type() {
                if (i < full.length) { cmd.textContent = full.slice(0, ++i); later(type, 28); return; }
                var n = 1;
                (function next() {
                    if (n < lines.length) { lines[n++].classList.remove('is-wait'); later(next, 140); }
                    else if (done) later(done, 2600);
                })();
            })();
        };
        var order = ['audit', 'apply', 'confirm'];
        var play = function (k) { if (auto && k < order.length) show(order[k], function () { play(k + 1); }); };
        cmds.addEventListener('click', function (e) {
            var b = e.target.closest('button');
            if (b) { auto = false; show(b.dataset.step); }
        });
        tty.classList.add('is-live');
        cmds.hidden = false;
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (es) {
                if (es[0].isIntersecting) { io.disconnect(); later(function () { play(0); }, still ? 0 : 600); }
            });
            io.observe(tty);
        } else play(0);
    }

    /* ":" jump palette: Hardline pages, this page's sections, every control. */
    var jump = root.querySelector('[data-hl-jump]');
    if (!jump || !window.HTMLDialogElement) return;
    var items = [], loaded = false, sel = 0, shown = [];
    root.querySelectorAll('.hl-subnav-links a').forEach(function (a) {
        items.push({ k: 'page', t: a.textContent.replace(/^\d+/, ''), h: a.getAttribute('href') });
    });
    items.unshift({ k: 'page', t: 'overview', h: '/hardline/' });
    root.querySelectorAll('.hl-body h2[id]').forEach(function (h) {
        items.push({ k: 'section', t: h.textContent, h: '#' + h.id });
    });
    var addControls = function (doc, base) {
        doc.querySelectorAll('ul.hl-list li[id]').forEach(function (li) {
            var t = li.querySelector('.hl-title');
            items.push({ k: 'control', t: li.id + (t ? ' · ' + t.textContent : ''), h: base + '#' + li.id });
        });
    };
    var dlg = document.createElement('dialog');
    dlg.className = 'hl-pal';
    dlg.setAttribute('aria-label', 'Jump to');
    dlg.innerHTML = '<form method="dialog"><span aria-hidden="true">:</span><input type="text" autocomplete="off" spellcheck="false" placeholder="jump to a page, section or control" aria-label="Search" role="combobox" aria-expanded="true" aria-controls="hl-pal-list"></form><ul id="hl-pal-list" role="listbox"></ul>';
    document.body.appendChild(dlg);
    var input = dlg.querySelector('input'), list = dlg.querySelector('ul');
    var render = function () {
        var q = input.value.trim().toLowerCase();
        shown = items.filter(function (it) { return !q || (it.k + ' ' + it.t).toLowerCase().indexOf(q) > -1; }).slice(0, 60);
        sel = Math.min(sel, Math.max(shown.length - 1, 0));
        list.innerHTML = '';
        if (!shown.length) { list.innerHTML = '<li class="hl-pal-empty">no match</li>'; return; }
        shown.forEach(function (it, i) {
            var li = document.createElement('li'), a = document.createElement('a'), s = document.createElement('small'), t = document.createElement('span');
            a.href = it.h; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', String(i === sel)); a.tabIndex = -1;
            s.textContent = it.k; t.textContent = it.t;
            a.append(s, t); li.appendChild(a); list.appendChild(li);
        });
        var cur = list.querySelector('[aria-selected="true"]');
        if (cur) cur.scrollIntoView({ block: 'nearest' });
    };
    var go = function (it) {
        dlg.close();
        if (it.h.charAt(0) === '#') { var el = document.getElementById(it.h.slice(1)); if (el) { el.scrollIntoView(); history.replaceState(null, '', it.h); } }
        else location.href = it.h;
    };
    var open = function () {
        input.value = ''; sel = 0; render(); dlg.showModal(); input.focus();
        if (loaded) return;
        loaded = true;
        if (root.querySelector('ul.hl-list li[id]')) { addControls(document, ''); render(); return; }
        fetch('/hardline/controls/', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
            addControls(new DOMParser().parseFromString(html, 'text/html'), '/hardline/controls/'); render();
        }).catch(function () { loaded = false; });
    };
    input.addEventListener('input', function () { sel = 0; render(); });
    input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + shown.length) % Math.max(shown.length, 1); render(); }
        else if (e.key === 'Enter') { e.preventDefault(); if (shown[sel]) go(shown[sel]); }
    });
    list.addEventListener('click', function (e) {
        var a = e.target.closest('a');
        if (!a) return;
        e.preventDefault();
        go(shown[[].indexOf.call(list.querySelectorAll('a'), a)]);
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    jump.hidden = false;
    jump.addEventListener('click', open);
    document.addEventListener('keydown', function (e) {
        if (e.key !== ':' || e.metaKey || e.ctrlKey || e.altKey || dlg.open) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        e.preventDefault(); open();
    });
})();
